// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 600px) {
  .Online_online__ZQQgz h1 span {
    width: min-content;
  }
  .Online_online__ZQQgz h1 img {
    align-self: flex-end;
  }
}
.Online_online__ZQQgz .Online_box_content__kwII4 {
  display: grid;
  grid-template-columns: 3fr 2fr 2fr;
  margin-right: -50px;
}
@media (max-width: 890px) {
  .Online_online__ZQQgz .Online_box_content__kwII4 {
    margin-right: 0;
  }
}
@media (max-width: 860px) {
  .Online_online__ZQQgz .Online_box_content__kwII4 {
    grid-template-columns: 3fr 2fr;
  }
}
@media (max-width: 720px) {
  .Online_online__ZQQgz .Online_box_content__kwII4 {
    grid-template-columns: 1fr;
  }
}
.Online_online__ZQQgz .Online_box_content__kwII4 .Online_text__unYmG {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
}
.Online_online__ZQQgz .Online_box_content__kwII4 .Online_text__unYmG p {
  margin: 0;
  padding: 0;
}
@media (max-width: 860px) {
  .Online_online__ZQQgz .Online_box_content__kwII4 .Online_text__unYmG {
    align-items: center;
  }
}
@media (max-width: 700px) {
  .Online_online__ZQQgz .Online_box_content__kwII4 .Online_text__unYmG {
    margin-top: 20px;
  }
}
.Online_online__ZQQgz .Online_box_content__kwII4 .Online_text__unYmG .Online_comment_add__QcGV- {
  max-width: 100%;
  padding-top: 20px;
  display: none;
}
@media (max-width: 860px) {
  .Online_online__ZQQgz .Online_box_content__kwII4 .Online_text__unYmG .Online_comment_add__QcGV- {
    display: block;
    margin: 0 -4% 0 0;
  }
}
.Online_online__ZQQgz .Online_box_content__kwII4 .Online_text__unYmG .Online_comment_text__ELKHc {
  max-width: 80%;
}
@media (max-width: 860px) {
  .Online_online__ZQQgz .Online_box_content__kwII4 .Online_text__unYmG .Online_comment_text__ELKHc {
    object-fit: cover;
    object-position: bottom;
    aspect-ratio: 2.1/1;
    margin: -10px 4% 0 0;
  }
}
@media (max-width: 860px) {
  .Online_online__ZQQgz .Online_box_content__kwII4 .Online_text__unYmG img {
    max-width: 80% !important;
    width: 80% !important;
  }
}
@media (max-width: 520px) {
  .Online_online__ZQQgz .Online_box_content__kwII4 .Online_text__unYmG img {
    max-width: 100% !important;
    width: 100% !important;
  }
}
.Online_online__ZQQgz .Online_box_content__kwII4 .Online_phone__Ii3oy {
  width: 100%;
  max-width: 390px;
}
@media (max-width: 1280px) {
  .Online_online__ZQQgz .Online_box_content__kwII4 .Online_phone__Ii3oy {
    max-width: 350px;
  }
}
@media (max-width: 1180px) {
  .Online_online__ZQQgz .Online_box_content__kwII4 .Online_phone__Ii3oy {
    max-width: 300px;
  }
}
@media (max-width: 860px) {
  .Online_online__ZQQgz .Online_box_content__kwII4 .Online_phone__Ii3oy {
    grid-row: 1/3;
    grid-column-start: 2;
  }
}
@media (max-width: 700px) {
  .Online_online__ZQQgz .Online_box_content__kwII4 .Online_phone__Ii3oy {
    grid-row: 1/3;
    grid-column: 1/3;
    margin: 0 auto;
  }
}
.Online_online__ZQQgz .Online_box_content__kwII4 .Online_phone__Ii3oy img {
  width: 100%;
}
@media (max-width: 860px) {
  .Online_online__ZQQgz .Online_box_content__kwII4 .Online_comment__lwZxw {
    display: none;
  }
}
.Online_online__ZQQgz .Online_box_content__kwII4 .Online_comment__lwZxw img {
  max-width: 110%;
  margin-left: -20px;
}`, "",{"version":3,"sources":["webpack://./src/components/Online/Online.module.scss"],"names":[],"mappings":"AAGG;EAEM;IACG,kBAAA;EAHV;EAKO;IACG,oBAAA;EAHV;AACF;AAOG;EACG,aAAA;EACA,kCAAA;EACA,mBAAA;AALN;AAOM;EALH;IAMM,eAAA;EAJP;AACF;AAMM;EATH;IAUM,8BAAA;EAHP;AACF;AAKM;EAbH;IAcM,0BAAA;EAFP;AACF;AAIM;EACG,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;AAFT;AAIS;EACG,SAAA;EACA,UAAA;AAFZ;AAKS;EAXH;IAYM,mBAAA;EAFV;AACF;AAIS;EAfH;IAgBM,gBAAA;EADV;AACF;AAIS;EACG,eAAA;EACA,iBAAA;EACA,aAAA;AAFZ;AAIY;EALH;IAMM,cAAA;IACA,iBAAA;EADb;AACF;AAIS;EACG,cAAA;AAFZ;AAIY;EAHH;IAIM,iBAAA;IACA,uBAAA;IACA,mBAAA;IACA,oBAAA;EADb;AACF;AAIS;EACG;IACG,yBAAA;IACA,qBAAA;EAFb;AACF;AAKS;EACG;IACG,0BAAA;IACA,sBAAA;EAHb;AACF;AAOM;EACG,WAAA;EACA,gBAAA;AALT;AAOS;EAJH;IAKM,gBAAA;EAJV;AACF;AAMS;EARH;IASM,gBAAA;EAHV;AACF;AAKS;EAZH;IAaM,aAAA;IACA,oBAAA;EAFV;AACF;AAIS;EAjBH;IAkBM,aAAA;IACA,gBAAA;IACA,cAAA;EADV;AACF;AAGS;EACG,WAAA;AADZ;AAKS;EADH;IAEM,aAAA;EAFV;AACF;AAIS;EACG,eAAA;EACA,kBAAA;AAFZ","sourcesContent":["\n\n.online{\n   @media (max-width: 600px) {\n      h1{\n         span{\n            width: min-content;\n         }\n         img{\n            align-self: flex-end;\n         }\n      }  \n   }\n\n   .box_content{\n      display: grid;\n      grid-template-columns: 3fr 2fr 2fr;\n      margin-right: -50px;\n\n      @media (max-width: 890px) {\n         margin-right: 0;\n      }\n\n      @media (max-width: 860px) {\n         grid-template-columns: 3fr 2fr;\n      }\n\n      @media (max-width: 720px) {\n         grid-template-columns: 1fr;\n      }\n\n      .text{\n         display: flex;\n         flex-direction: column;\n         align-items: flex-end;\n         justify-content: space-between;\n\n         p{\n            margin: 0;\n            padding: 0;\n         }\n\n         @media (max-width: 860px) {\n            align-items: center;\n         }  \n\n         @media (max-width: 700px) {\n            margin-top: 20px;\n         }\n\n\n         .comment_add{\n            max-width: 100%;  \n            padding-top: 20px;\n            display: none;\n\n            @media (max-width: 860px) {\n               display: block;\n               margin: 0 -4% 0 0;\n            }   \n         }\n\n         .comment_text{\n            max-width: 80%;  \n\n            @media (max-width: 860px) {\n               object-fit: cover;\n               object-position: bottom;\n               aspect-ratio: 2.1 / 1;\n               margin: -10px 4% 0 0;\n            }  \n         }\n\n         @media (max-width: 860px) {\n            img{\n               max-width: 80% !important;  \n               width: 80% !important;\n            }\n         }\n\n         @media (max-width: 520px) {\n            img{\n               max-width: 100% !important;  \n               width: 100% !important;\n            }\n         }\n\n      }\n      .phone{\n         width: 100%;\n         max-width:390px;\n\n         @media (max-width: 1280px) {\n            max-width:350px;\n         }\n\n         @media (max-width: 1180px) {\n            max-width:300px;\n         }\n\n         @media (max-width: 860px) {\n            grid-row: 1 / 3;\n            grid-column-start: 2;\n         }\n\n         @media (max-width: 700px) {\n            grid-row: 1 / 3;\n            grid-column: 1 / 3;\n            margin: 0 auto;\n         }\n\n         img{\n            width: 100%;\n         }\n      }\n      .comment{\n         @media (max-width: 860px) {\n            display: none;\n         }  \n\n         img{\n            max-width: 110%;\n            margin-left: -20px;\n         }\n      }\n   }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"online": `Online_online__ZQQgz`,
	"box_content": `Online_box_content__kwII4`,
	"text": `Online_text__unYmG`,
	"comment_add": `Online_comment_add__QcGV-`,
	"comment_text": `Online_comment_text__ELKHc`,
	"phone": `Online_phone__Ii3oy`,
	"comment": `Online_comment__lwZxw`
};
export default ___CSS_LOADER_EXPORT___;
